var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTagIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.90613 7.76971C4.75261 7.92324 4.56237 8 4.33542 8C4.10847 8 3.91823 7.92324 3.76471 7.76971L0.2403 4.24531C0.166875 4.17188 0.108536 4.08511 0.0652816 3.98498C0.0217606 3.88486 0 3.77806 0 3.66458V0.801001C0 0.580726 0.0784982 0.39209 0.235494 0.235094C0.392224 0.0783646 0.580726 0 0.801001 0H3.66458C3.77806 0 3.88486 0.021627 3.98498 0.0648811C4.08511 0.108402 4.17188 0.166875 4.24531 0.2403L7.76971 3.77472C7.92324 3.92824 8 4.11675 8 4.34023C8 4.56397 7.92324 4.75261 7.76971 4.90613L4.90613 7.76971ZM1.80225 2.403C1.96913 2.403 2.11091 2.34453 2.22758 2.22758C2.34453 2.11091 2.403 1.96913 2.403 1.80225C2.403 1.63538 2.34453 1.4936 2.22758 1.37692C2.11091 1.25997 1.96913 1.2015 1.80225 1.2015C1.63538 1.2015 1.4936 1.25997 1.37692 1.37692C1.25997 1.4936 1.2015 1.63538 1.2015 1.80225C1.2015 1.96913 1.25997 2.11091 1.37692 2.22758C1.4936 2.34453 1.63538 2.403 1.80225 2.403Z",
    fill: "#FF906D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIcon);
export default __webpack_public_path__ + "static/media/tagIcon.2f098b8b5792238176d23b78f37f389e.svg";
export { ForwardRef as ReactComponent };